import { FC, ReactElement, JSXElementConstructor } from 'react';
import Tooltip from '@stripcash/ui-kit/components/Tooltip';

import { Section } from 'common/selectors/sidebar/utils';

type TabGroupWrapperProps = {
  children: ReactElement<any, string | JSXElementConstructor<any>>;
  hasTooltip: boolean;
  gap?: number;
} & Pick<Section, 'title'>;

const TabGroupWrapper: FC<TabGroupWrapperProps> = ({
  hasTooltip,
  gap = 15,
  title,
  children,
}) => (
  <>
    {hasTooltip ? (
      <Tooltip text={title} placement="right" gap={gap}>
        {children}
      </Tooltip>
    ) : (
      children
    )}
  </>
);

export default TabGroupWrapper;
